import React from 'react'
import { TranslateFunction } from '@/utils/translate/translate-client'
import {
  GParagraphLG,
  GParagraphXL,
  GResponsiveText,
} from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'

export const getIwasIntroText = (t: TranslateFunction) => (
  <div>
    <GResponsiveText
      color="giveaway-text-subtle-light"
      className="mb-6 pt-3"
      MobileTextComponent={GParagraphLG}
      DesktopTextComponent={GParagraphXL}
    >
      {t(
        'IwasPrizeParagraph1',
        'The world needs more stories like I Was A Stranger. With a 9.3/10 IMDb score and standing ovations worldwide, it’s a story of human triumph that demands the big screen.',
      )}
    </GResponsiveText>

    <GResponsiveText
      color="giveaway-text-subtle-light"
      className="mb-6 pt-3"
      MobileTextComponent={GParagraphLG}
      DesktopTextComponent={GParagraphXL}
    >
      {t(
        'IwasPrizeParagraph3',
        'In the heart of Syria’s war, families, doctors, and unlikely heroes risk everything to survive. Their paths cross in a gripping tale of courage, loss and hope—where a smuggler, a doctor, and a soldier show what it means to stand for humanity. I Was a Stranger is a film that’s swept 41 festival wins, from Berlinale to Cairo, and left audiences in tears.',
      )}
    </GResponsiveText>
  </div>
)

export const getIwasPrizeText = (t: TranslateFunction) => (
  <div>
    <GParagraphLG color="giveaway-text-subtle-light" className="mb-8">
      {t(
        'IwasGrandPrizeDesc',
        'One grand prize winner and their plus one will embark on the journey of a lifetime that includes:',
      )}
    </GParagraphLG>
    <ul className="list-disc pl-6">
      <li className="mb-2">
        <GParagraphLG color="giveaway-text-subtle-light">
          {t('MediterraneanLuxuryText', 'Luxury Accommodations in the Mediterranean.')}
        </GParagraphLG>
      </li>
      <li className="mb-2">
        <GParagraphLG color="giveaway-text-subtle-light">
          {t('visitTurkey', 'Visit Turkey and Greece and other key Mediterranean locations.')}
        </GParagraphLG>
      </li>
      <li className="mb-2">
        <GParagraphLG color="giveaway-text-subtle-light">
          {t('tourlikeAlocal', 'Tour like a local and visit the best these cultures have to offer.')}
        </GParagraphLG>
      </li>
      <li className="mb-2">
        <GParagraphLG color="giveaway-text-subtle-light">
          {t('1kDonation', '$1k donation to a refugee non-profit of your choice.')}
        </GParagraphLG>
      </li>
      <li className="mb-2">
        <GParagraphLG color="giveaway-text-subtle-light">
          {t('CotopaxiBag', 'A Cotopaxi Bag for all your travel needs.')}
        </GParagraphLG>
      </li>
      <li className="mb-2">
        <GParagraphLG color="giveaway-text-subtle-light">
          {t('iWasresilience', 'Every stop echoes the resilience of those who dared to hope against all.')}
        </GParagraphLG>
      </li>
    </ul>
  </div>
)

export const getIwasSecondPrizeText = (t: TranslateFunction) => (
  <div>
    <GParagraphLG color="giveaway-text-subtle-light" className="mb-2">
      {t('IwasSecondPrizeDesc', '9 Additional Winners will receive:')}
    </GParagraphLG>
    <ul className="list-disc pl-6">
      <li className="mb-2">
        <GParagraphLG color="giveaway-text-subtle-light">
          {t('cotopaxiBag', 'A Cotopaxi Bag ($250 value).')}
        </GParagraphLG>
      </li>
    </ul>
  </div>
)

export const getIwasConfig = () => {
  return {
    grandPrizes: [
      {
        image:
          'https://images.angelstudios.com/image/upload/v1761595667/iwas/IWAS_Giveaway_Image-Ads_16x9_The_Mediterranean.webp',
        alt: '7-10 Day Trip for 2 to the Mediterranean',
        title: '7-10 Day Trip for 2 to the Mediterranean',
        value: '$20,000',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1761595667/iwas/IWAS_Giveaway_Image-Ads_16x9_Cash_Prize.webp',
        alt: '$6.5K Cash',
        title: '$6.5K Cash',
        value: '$6,500',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1761595667/iwas/IWAS_Giveaway_Image-Ads_16x9_The_Mediterranean_copy.webp',
        alt: 'Cotopaxi Bag',
        title: 'Cotopaxi Bag',
        value: '$250',
      },
    ],
    grandPrizeDetails: {
      title: 'Paths of Hope Trip',
      value: '$20,000',
    },
  }
}
